import axios from 'axios';
import { API_URL } from '../config/apiConfig';

const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
    };
};

export const getDiscountCodes = async (affiliateId) => {
    const response = await axios.get(`${API_URL}/discount-codes`, {
        params: { affiliateId },
        headers: getAuthHeaders()
    });
    return response.data;
};

export const createDiscountCode = async (data) => {
    const response = await axios.post(`${API_URL}/discount-codes`, data, {
        headers: getAuthHeaders()
    });
    return response.data;
};

export const deleteDiscountCode = async (id) => {
    const response = await axios.delete(`${API_URL}/discount-codes/${id}`, {
        headers: getAuthHeaders()
    });
    return response.data;
};

export const validateDiscountCode = async (code, affiliateId, amount, planId = null) => {
    const response = await axios.post(
        `${API_URL}/discount-codes/validate`,
        { code, affiliateId, amount, planId },
        { headers: getAuthHeaders() }
    );
    return response.data;
};
